import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import _ from 'lodash';
import { I18N } from './I18N';

class EllipsisBox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initDone: false,
      showMore: false,
      shortText: '',
      shouldShowMoreBtn: false
    };
    this.ref = React.createRef();
    this.placeHolderRef = React.createRef();
    this.text = props.text;
  }

  componentDidMount() {
    this.cutText();
    window.addEventListener('resize', _.throttle(this.handleResize, 500));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', _.throttle(this.handleResize, 500));
  }

  handleResize=() => {
    this.setState({
      initDone: false
    }, this.cutText);
  }

    cutText=() => {
      let { text } = this.props;
      const { lineHeight, lineClamp } = this.props;
      // This 2 is for IE 1px bug
      const maxHeight = (lineHeight + 2) * lineClamp;

      const container = this.placeHolderRef.current;
      const child = container.firstChild;
      const containerHeight = container.clientHeight;
      const shouldShowMoreBtn = containerHeight > maxHeight + 1;
      // Check if the paragraph's height is taller than the container's height.

      while (container.clientHeight > maxHeight + 1) {
        if (lineHeight * lineClamp / (container.clientHeight - lineHeight) < 1) {
          text = `${text.slice(
            0,
            Math.floor(
              lineHeight * lineClamp / (container.clientHeight - lineHeight) * text.length
            ),
          )}`;
          child.textContent = `${text}`;
        } else {
          text = `${text.replace(/[.]{3}$/, '').slice(0, -1)}`;
          child.textContent = `${text}`;
        }
      }

      this.setState({
        initDone: true,
        shortText: text,
        shouldShowMoreBtn
      });
    }

    toggleDetails=() => {
      const { showMore } = this.state;
      this.setState({
        showMore: !showMore
      });
    }

    render() {
      const { showMore, initDone, shortText, shouldShowMoreBtn } = this.state;
      const { lineHeight, text, isShowMore, textClass, textId } = this.props;
      const showEllipsisText = shouldShowMoreBtn && !showMore;
      return (
        <div className={textClass}>
          <div style={{
            lineHeight: `${lineHeight}px`,
            width: '100%',
            wordBreak: 'break-word',
            wordWrap: 'break-word',
            overflow: 'hidden'
          }}
          >
            {initDone && (
              <div>
                <span
                  className="align-middle"
                  style={{ whiteSpace: showEllipsisText ? 'normal' : 'pre-wrap' }}
                >
                  {showEllipsisText ? shortText : text}
                </span>
                {
                  shouldShowMoreBtn && (
                    isShowMore
                      ? (
                        <Button
                          onClick={this.toggleDetails}
                          color="link"
                          className="p-1 py-0 text-decoration-none"
                        >
                          <I18N>
                            {showMore ? 'ssp.location.hide' : 'task.event.tasklist.showMore'}
                          </I18N>
                        </Button>
                      )
                      : '...'
                  )
                }
              </div>
            )}
          </div>
          {
            !initDone
            && (
              <div
                ref={this.placeHolderRef}
                style={{
                  position: 'absolute',
                  lineHeight: `${lineHeight}px`,
                  visibility: 'hidden',
                  top: 0,
                  left: 0,
                  width: '100%',
                  zIndex: -1
                }}
              >
                <span className="align-middle" style={{ whiteSpace: 'pre-wrap' }}>{text}</span>
                <Button onClick={() => {}} color="link" className="px-1 py-0 text-decoration-none">
                  {isShowMore ? (<I18N>task.event.tasklist.showMore</I18N>) : '...'}
                </Button>
              </div>
            )}
        </div>

      );
    }
}

EllipsisBox.propTypes = {
  text: PropTypes.string.isRequired,
  lineClamp: PropTypes.number,
  lineHeight: PropTypes.number,
  isShowMore: PropTypes.bool,
  textClass: PropTypes.string
};
EllipsisBox.defaultProps = {
  lineClamp: 2,
  lineHeight: 20,
  isShowMore: false,
  textClass: ''
};

export default EllipsisBox;
